import React, { useState } from 'react'
import {
  Grid,
  List,
  Card,
  CardHeader,
  CardContent,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
  Button,
  Divider,
} from '@mui/material'
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material'
import { useTranslate } from 'react-admin'

function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1)
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1)
}

function union(a, b) {
  return [...a, ...not(b, a)]
}

export const TransferList = ({ leftData, rightData, setter }) => {
  const translate = useTranslate()
  const [checked, setChecked] = useState([])

  const leftChecked = intersection(checked, leftData)
  const rightChecked = intersection(checked, rightData)

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value)
    const newChecked = [...checked]

    if (currentIndex === -1) {
      newChecked.push(value)
    } else {
      newChecked.splice(currentIndex, 1)
    }

    setChecked(newChecked)
  }

  const numberOfChecked = (items) => intersection(checked, items).length

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items))
    } else {
      setChecked(union(checked, items))
    }
  }

  const handleCheckedRight = () => {
    const left = not(leftData, leftChecked)
    const right = rightData.concat(leftChecked)
    setter(left, right)
    setChecked(not(checked, leftChecked))
  }

  const handleCheckedLeft = () => {
    const left = leftData.concat(rightChecked)
    const right = not(rightData, rightChecked)
    setter(left, right)
    setChecked(not(checked, rightChecked))
  }

  const customList = (title, items) => (
    <Card className='transferListCard'>
      <CardHeader
        sx={{ px: 2, py: 1 }}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={numberOfChecked(items) === items.length && items.length !== 0}
            indeterminate={numberOfChecked(items) !== items.length && numberOfChecked(items) !== 0}
            disabled={items.length === 0}
            inputProps={{
              'aria-label': 'all items selected',
            }}
          />
        }
        title={title}
        subheader={`${numberOfChecked(items)}/${items.length} ${translate('ra.field.selected')}`}
      />
      <Divider />
      <CardContent>
        <List dense component='div' role='list' className='cardList'>
          {items.map((value) => {
            if (value) {
              const labelId = `transfer-list-all-item-${value?.id}-label`
              return (
                <ListItem key={value?.id} role='listitem' button name={6} onClick={handleToggle(value)}>
                  <ListItemIcon>
                    <Checkbox
                      checked={checked.indexOf(value) !== -1}
                      tabIndex={-1}
                      disableRipple
                      inputProps={{
                        'aria-labelledby': labelId,
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText id={labelId} primary={value.description} />
                </ListItem>
              )
            }
            return null
          })}
          <ListItem />
        </List>
      </CardContent>
    </Card>
  )

  return (
    <>
      <Grid
        container
        spacing={2}
        justifyContent='center'
        alignItems='center'
        className='transferListComponent'
      >
        <Grid item xs={5}>
          {customList(translate('ra.field.choices'), leftData)}
        </Grid>
        <Grid item xs={2}>
          <Grid container direction='column' alignItems='center'>
            <Button
              variant='outlined'
              onClick={handleCheckedRight}
              disabled={leftChecked.length === 0}
              aria-label='move selected right'
            >
              <KeyboardArrowRight />
            </Button>
            <Button
              variant='outlined'
              onClick={handleCheckedLeft}
              disabled={rightChecked.length === 0}
              aria-label='move selected left'
            >
              <KeyboardArrowLeft />
            </Button>
          </Grid>
        </Grid>
        <Grid item xs={5}>
          {customList(translate('ra.field.chosen'), rightData)}
        </Grid>
      </Grid>
    </>
  )
}
